// extracted by mini-css-extract-plugin
export default {"container":"unauthorizedApp_container__Mquca","icon_wrapper":"unauthorizedApp_icon_wrapper__nGQtj","form_wrapper":"unauthorizedApp_form_wrapper__rnRwG"};